function firstFiniteNumber(candidates) {
    for (const value of candidates) {
        const numeric = Number(value);
        if (Number.isFinite(numeric)) return numeric;
    }
    return null;
}

export function resolvePagedTotals(data, fallbackPageSize = 1) {
    const total = firstFiniteNumber([
        data?.totalItems,
        data?.totalCount,
        data?.total,
        data?.count,
        data?.meta?.totalItems,
        data?.meta?.totalCount,
        data?.meta?.total,
        data?.pagination?.totalItems,
        data?.pagination?.totalCount,
        data?.pagination?.total,
    ]) ?? 0;

    const pageSize = Math.max(
        1,
        firstFiniteNumber([
            data?.pageSize,
            data?.pagination?.pageSize,
            data?.meta?.pageSize,
            fallbackPageSize,
        ]) ?? 1,
    );

    const totalPages = firstFiniteNumber([
        data?.totalPages,
        data?.pageCount,
        data?.pages,
        data?.meta?.totalPages,
        data?.pagination?.totalPages,
    ]);

    const normalizedTotal = Math.max(0, Math.floor(total));
    const normalizedTotalPages = totalPages != null
        ? Math.max(1, Math.floor(totalPages))
        : Math.max(1, Math.ceil(normalizedTotal / pageSize));

    return {
        total: normalizedTotal,
        totalPages: normalizedTotalPages,
    };
}
